<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card title="استيراد / تصدير Excel" class="mb-2">
          <b-card-text>
            تصدير كل الجداول (أوراق متعددة في ملف .xlsx واحد) أو استيراد نفس
            التنسيق بعد التعديل. راعِ ترتيب العلاقات عند الاستيراد (الأوراق
            تُعالج بالترتيب داخل السيرفر).
          </b-card-text>
          <b-button
            variant="outline-secondary"
            class="mr-1 mb-1"
            :disabled="templateLoading"
            @click="downloadTemplate"
          >
            <span v-if="templateLoading">جاري التحميل...</span>
            <span v-else>تنزيل قالب الاستيراد (Template)</span>
          </b-button>
          <b-button variant="primary" class="mr-1 mb-1" :disabled="exporting" @click="downloadExport">
            <span v-if="exporting">جاري التصدير...</span>
            <span v-else>تصدير الكل (Excel)</span>
          </b-button>
          <div class="mt-2">
            <b-form-file
              v-model="file"
              accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              placeholder="اختر ملف Excel للاستيراد"
              drop-placeholder="أفلت الملف هنا"
            />
            <b-button
              variant="success"
              class="mt-1"
              :disabled="!file || importing"
              @click="runImport"
            >
              <span v-if="importing">جاري الاستيراد...</span>
              <span v-else>استيراد</span>
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-if="importReport">
      <b-col cols="12">
        <b-card title="نتيجة الاستيراد">
          <pre class="mb-0" style="white-space: pre-wrap; font-size: 12px">{{
            JSON.stringify(importReport, null, 2)
          }}</pre>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BCard, BCardText, BButton, BFormFile } from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import dataExchangeApi from "@/apiServices/dataExchangeApi";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BButton,
    BFormFile,
  },
  data() {
    return {
      file: null,
      exporting: false,
      templateLoading: false,
      importing: false,
      importReport: null,
    };
  },
  methods: {
    async downloadTemplate() {
      this.templateLoading = true;
      try {
        const res = await dataExchangeApi.downloadImportTemplate();
        const blob = new Blob([res.data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "osama-lms-import-template.xlsx";
        a.click();
        window.URL.revokeObjectURL(url);
        this.$toast({
          component: ToastificationContent,
          props: { title: "تم تنزيل القالب", variant: "success" },
        });
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: e.response?.data?.message || e.message || "فشل تنزيل القالب",
            variant: "danger",
          },
        });
      } finally {
        this.templateLoading = false;
      }
    },
    async downloadExport() {
      this.exporting = true;
      this.importReport = null;
      try {
        const res = await dataExchangeApi.exportAll();
        const blob = new Blob([res.data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `osama-lms-export-${Date.now()}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
        this.$toast({
          component: ToastificationContent,
          props: { title: "تم التصدير", variant: "success" },
        });
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: e.response?.data?.message || e.message || "فشل التصدير",
            variant: "danger",
          },
        });
      } finally {
        this.exporting = false;
      }
    },
    async runImport() {
      if (!this.file) return;
      this.importing = true;
      this.importReport = null;
      try {
        const res = await dataExchangeApi.importAll(this.file);
        this.importReport = res.data?.data || res.data;
        this.$toast({
          component: ToastificationContent,
          props: { title: "اكتمل الاستيراد", variant: "success" },
        });
        this.file = null;
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: e.response?.data?.message || e.message || "فشل الاستيراد",
            variant: "danger",
          },
        });
      } finally {
        this.importing = false;
      }
    },
  },
};
</script>
